import { Button } from "react-bootstrap";
import Sections from "./helpers/sections";
import PageTemplate from "./helpers/pagetemp";
import Discord from "./helpers/DiscordSection";

const JOIN_FORM_URL = "https://forms.gle/PceEJ4oxTq8Mf1Sd8";
const MATHDASH_SIGNUP_URL = "https://mathdash.com/";
const MATHDASH_GROUP_URL = "https://mathdash.com/group/oregon-math-circle";
const CONTACT_EMAIL = "oregonmathcircle@gmail.com";

function MyJoin() {
    var form_section = [
        <div className="spacious-text">
            <p>
                Ready to officially join Oregon Math Circle for the <strong>2026–27 season</strong>? Fill out our join form below — this also adds you to our mailing list for the year.
            </p>
            <div className="join-cta-wrapper">
                <Button
                    className="join-cta-button"
                    href={JOIN_FORM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Fill Out the Join Form
                </Button>
            </div>
        </div>
    ];

    var discord_section = [
        <div className="spacious-text">
            <p>
                For the most frequent updates, join our Discord server below. Once you're in, head to the <strong>#info channel</strong> for everything you need to get started. <strong>Parents are welcome</strong> to create an account and join too — we have dedicated parent roles.
            </p>
        </div>,
        <Discord />
    ];

    var mathdash_section = [
        <div className="spacious-text">
            <p>
                We use <strong>MathDash</strong> to run our Problem of the Day (POTD) sets and leaderboards. Here's how to get set up:
            </p>
            <ol>
                <li>
                    Create an account at{" "}
                    <a href={MATHDASH_SIGNUP_URL} target="_blank" rel="noopener noreferrer">mathdash.com</a>.
                </li>
                <li>
                    Join our club at{" "}
                    <a href={MATHDASH_GROUP_URL} target="_blank" rel="noopener noreferrer">mathdash.com/group/oregon-math-circle</a>.
                </li>
            </ol>
            <p>
                If you don't join the club, you won't show up on any of the leaderboards or rankings, which are posted live on Discord.
            </p>
            <p>
                <strong>Note:</strong> POTDs are currently off for the summer, but will restart at the beginning of the school year.
            </p>
        </div>
    ];

    var contact_section = [
        <div className="spacious-text">
            <p>
                Have any questions? Reach out to us at{" "}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </p>
        </div>
    ];

    var sections = [
        {
            "title": "Join the Club",
            "items": form_section,
            enhance: true
        },
        {
            "title": "Join Our Discord!",
            "items": discord_section,
            enhance: true
        },
        {
            "title": "Join MathDash",
            "items": mathdash_section,
            enhance: true
        },
        {
            "title": "Questions?",
            "items": contact_section,
            enhance: true
        }
    ];

    return (
        <PageTemplate id="join-page">
            <h1 className="my-5">Join Oregon Math Circle</h1>
            <Sections sections={sections} title_block={({ children }) => (<h4>{children}</h4>)} />
        </PageTemplate>
    );
}

export default MyJoin;
